<div class="offers-card">
    <div class="offers-card-header">
        <h1><img src="./assets/images/icons/file_check_gray.png" alt="file_check_gray">
            <span>évènements organiser <strong *ngIf="reservations">({{ reservations.length || '0' }})</strong></span>
        </h1>
    </div>

    <!-- Empty state -->
    <div *ngIf="!reservations || (reservations && reservations.length === 0)" class="empty-offer-state">
        <p>Aucune évènements en</p>
    </div>

    <div class="reservations-container">
        @for (reservation of reservations; track reservation){
        <div class="reservation-card-container pointer" (click)="details(reservation.id)">
            <div class="reservation-card">
                <div class="reservation-image-col">
                    <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
                </div>

                <div class="reservation-content-col">
                    <div class="col-header">
                        <h3 class="reservation-title">
                            <span><strong>{{ reservation.eventName }}</strong> / {{ reservation.clientName }}</span>
                        </h3>
                        <div class="right-side">
                            <div class="status-badge">
                                <span class="status-dot" [ngClass]="getReservationAdminStatusClass(reservation)"></span>
                                <span class="status-text">{{ getReservationAdminStatusText(reservation) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="reservation-footer">
                        <div class="info-col">
                            <div class="data">
                                <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon"><span>{{ reservation.requiredAgents }}</span>
                            </div>
                            <div class="data">
                                <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon"><span>{{ reservation.startDateTime }}</span>
                            </div>
                            <div *ngIf="reservation.address" class="data">
                                <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon"><span>{{ formatAddress(reservation.address) }}</span>
                            </div>
                        </div>
                        <div class="creation-date">
                            {{ reservation.createdAt }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>